import React from "react";
import className from "classnames/bind";

/**
 * Component hiển thị thông báo lỗi
 * @param {Object} props
 * @param {string} props.message - Thông báo lỗi
 * @param {Function} props.onRetry - Hàm retry khi có lỗi
 * @param {Object} props.styles - SCSS styles object
 */
const ErrorMessage = ({ message, onRetry, styles }) => {
  const cx = className.bind(styles);

  return (
    <div className={cx("error-message")}>
      <h2>Error</h2>
      <p>{message || "An unexpected error occurred"}</p>
      {onRetry && (
        <button 
          className={cx("retry-button")} 
          onClick={onRetry}
        >
          Try Again
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;
